import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {take} from 'rxjs/operators';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFireDatabase} from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor() {
  }


  // getSports() {
  //   return this.http.get('http://api.dev.44sportsreport.com/sports');
  // }
}
